'use client';

import { c as _c } from "react/compiler-runtime";
import dayjs from 'dayjs';
import { memo, useCallback, useEffect, useState } from 'react';
import { INVITE_EVENT_CONFIG } from '../constants';
const formatTime = (time: number) => time.toString().padStart(2, '0');
export const InviteCountdownTimer = memo(function InviteCountdownTimer() {
  const $ = _c(21);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
      isEnded: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [timeLeft, setTimeLeft] = useState(t0);
  const calculateTimeLeft = _temp;
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setTimeLeft(calculateTimeLeft());
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 10);
      return () => clearInterval(timer);
    };
    t2 = [calculateTimeLeft];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (timeLeft.isEnded) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex w-full items-center justify-center gap-12 bg-Gray-black/60 py-12 backdrop-blur-sm"><div className="flex h-32 items-center justify-center rounded-medium bg-Gray-550 px-16"><span className="text-center font-700 text-Gray-white typo-body4">마감</span></div><p className="text-center font-500 text-Gray-white typo-body3">이벤트가 종료되었습니다</p></div>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex h-32 items-center justify-center rounded-r-medium rounded-bl-medium rounded-tl-none bg-R-500 px-16"><span className="text-center font-700 uppercase text-Gray-white typo-body4">마감까지</span></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== timeLeft.days) {
    t4 = formatTime(timeLeft.days);
    $[5] = timeLeft.days;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== timeLeft.hours) {
    t5 = formatTime(timeLeft.hours);
    $[7] = timeLeft.hours;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== timeLeft.minutes) {
    t6 = formatTime(timeLeft.minutes);
    $[9] = timeLeft.minutes;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== timeLeft.seconds) {
    t7 = formatTime(timeLeft.seconds);
    $[11] = timeLeft.seconds;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== timeLeft.milliseconds) {
    t8 = formatTime(timeLeft.milliseconds);
    $[13] = timeLeft.milliseconds;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <div className="flex w-full items-center justify-center gap-12 bg-Gray-black/60 py-12 backdrop-blur-sm">{t3}<p className="text-center font-500 tabular-nums text-Gray-white typo-body3">{t4}일 {t5}시간{" "}{t6}분 {t7}초{" "}{t8}</p></div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
});
function _temp() {
  const diff = dayjs(INVITE_EVENT_CONFIG.eventEndDate).diff(dayjs());
  if (diff <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
      isEnded: true
    };
  }
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000 % 24),
    minutes: Math.floor(diff / 1000 / 60 % 60),
    seconds: Math.floor(diff / 1000 % 60),
    milliseconds: Math.floor(diff % 1000 / 10),
    isEnded: false
  };
}